import type { ReactNode } from "react";

import CookieBanner from "./CookieBanner";
import Header from "./Header";
import SiteFooter from "./SiteFooter";

interface LandingLayoutProps {
  children: ReactNode;
  headerVariant?: "default" | "overlay";
  showFooter?: boolean;
}

export default function LandingLayout({
  children,
  headerVariant = "default",
  showFooter = false,
}: LandingLayoutProps) {
  return (
    <div className="min-h-screen bg-[var(--color-page)] text-[var(--color-ink)]">
      <Header variant={headerVariant} />
      {children}
      {showFooter ? <SiteFooter /> : null}
      <CookieBanner />
    </div>
  );
}
